// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3kw2l","title":"Info_title__3J2NF","links":"Info_links__3Z6XQ","link":"Info_link__3o19q","logo":"Info_logo__3t_am"};